module.exports = __webpack_public_path__ + "static/media/kjetting.988964f2.mp3";